import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./ViewPage.css";

const ViewSupplier = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchSupplierDetails();
    }
  }, [id]);

  const fetchSupplierDetails = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.post("/supplier_detail.php", { id });
      
      if (response.data.head.code === 200) {
        const supplierData = response.data.body;
        const transformedSupplier = {
          id: supplierData.id,
          name: supplierData.name,
          phoneNo: supplierData.mobile,
          address: supplierData.address,
          city: supplierData.city,
          state: supplierData.state,
          pin_code: supplierData.pin_code,
          gstNo: supplierData.gst_no
        };
        setSupplier(transformedSupplier);
      } else {
        setError(response.data.head.msg || "Supplier not found");
      }
    } catch (err) {
      console.error("Error fetching supplier details:", err);
      setError("Failed to load supplier details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    fetchSupplierDetails();
  };

  if (loading) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">Supplier Details</h2>
        <Row>
          <Col>
            <div className="text-center py-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p className="mt-3">Loading supplier details...</p>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (error || !supplier) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">Supplier Details</h2>
        <Row>
          <Col>
            <div className="not-found-box">
              <p className="mb-3">{error || "Supplier not found."}</p>
              <div className="d-flex justify-content-center gap-3">
                <Button variant="secondary" onClick={() => navigate(-1)}>
                  Back
                </Button>
                <Button variant="primary" onClick={handleRetry}>
                  Retry
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">Supplier Details</h2>
       
      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          <div className="customer-details-table-wrapper">
            <table className="customer-view-table" role="table" aria-label={`Details for ${supplier.name}`}>
              <tbody>
                <tr>
                  <td className="field-cell">Supplier Name</td>
                  <td className="value-cell">{supplier.name}</td>
                </tr>

                <tr>
                  <td className="field-cell">Phone Number</td>
                  <td className="value-cell">{supplier.phoneNo || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Address</td>
                  <td className="value-cell">{supplier.address || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">City</td>
                  <td className="value-cell">{supplier.city || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">State</td>
                  <td className="value-cell">{supplier.state || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Pin Code</td>
                  <td className="value-cell">{supplier.pin_code || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">GST Number</td>
                  <td className="value-cell">{supplier.gstNo || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewSupplier;